export function createNotificationAwareTitleTemplate(
	baseTitleTemplate,
	unreadCount = 0
) {
	const normalizedBaseTitleTemplate =
		typeof baseTitleTemplate === 'function'
			? baseTitleTemplate
			: chunk => (chunk ? String(chunk) : '')
	const unreadPrefix = unreadCount > 0 ? `(${unreadCount}) ` : ''

	return chunk => `${unreadPrefix}${normalizedBaseTitleTemplate(chunk)}`
}
